import { getFileNameFromContentDisposition } from "@/common/helpers/file";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

export const VEHICLE_VALUATION_SNAPSHOT_DOWNLOAD_API_PATH = "/v1/vehicle-valuation/{uuid}/snapshot/download" as const;

export interface VehicleValuationSnapshotDownload {
  blob: Blob;
  fileName: string;
}

async function downloadVehicleValuationSnapshot(uuid: string): Promise<VehicleValuationSnapshotDownload> {
  const apiPath = VEHICLE_VALUATION_SNAPSHOT_DOWNLOAD_API_PATH.replace("{uuid}", uuid);
  const response = await alphartisApiAxios.get<Blob>(apiPath, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    fileName: getFileNameFromContentDisposition(
      response.headers["content-disposition"],
      `DAT-vehicle-valuation-snapshot-${uuid}.json`,
    ),
  };
}

export function useVehicleValuationSnapshotDownloadMutation() {
  return useMutation<VehicleValuationSnapshotDownload, Error, string>({
    mutationFn: downloadVehicleValuationSnapshot,
  });
}
